import React from "react";
import AnonymousPage from "@/models/base/AnonymousPage";
import {Button, ButtonType, PageContainer, PageHeader} from "@reapptor-apps/reapptor-react-components";
import ReactMarkdown from "react-markdown";
import {OccupationalHealthData, OccupationalHealthResponse} from "@/models/cms/OccupationalHealthResponse";
import styles from "./OccupationalHealth.module.scss";

import FenixAppController from "@/pages/FenixAppController";
import Localizer from "@/localization/Localizer";
import {PageRouteProvider} from "@reapptor-apps/reapptor-react-common";
import PageDefinitions from "@/providers/PageDefinitions";
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import {FaQuoteLeft} from "react-icons/fa";
import MetaTags from "@/components/MetaTags/MetaTags";

interface IOccupationalHealthProps {
}

export interface IOccupationalHealthParams {}

interface IOccupationalHealthState {
    data: OccupationalHealthData | null;
}

export default class OccupationalHealth extends AnonymousPage<IOccupationalHealthProps, IOccupationalHealthState> {
    state: IOccupationalHealthState = {
        data: null
    };

    async initializeAsync(): Promise<void> {
        await super.initializeAsync();
        const response: OccupationalHealthResponse = await this.getAsync(
            "/api/Application/GetOccupationalHealthData"
        );

        await this.setState({data: response.data});
    }

    async redirectToContactSupport() {
        await PageRouteProvider.redirectAsync(PageDefinitions.occupationalHealthOfferFormRoute);
    }
    
    async redirectToButtonUrl(url: string | undefined | null) {
        if(url)
            window.location.href = url;
    }

    public render(): React.ReactNode {

        return (
            <PageContainer fullWidth className={styles.pageContainer}>
                <MetaTags pageName="OccupationalHealth" />
                <PageHeader className={styles.pageHeader} title={Localizer.occupationalHealthPageTitle}/>
                <div className={styles.pageContent}>
                    <div className={styles.fluidContent}>
                        {this.state.data && (
                            <>
                                <h2>{this.state.data.attributes.title}</h2>
                                <ReactMarkdown>{this.state.data.attributes.content}</ReactMarkdown>
                                {(this.state.data.attributes.topButtonsEnabled && this.state.data.attributes.topButtons) &&
                                    <div className={styles.topButtonsDiv}>
                                        {this.state.data.attributes.topButtons.map((button, index) => {
                                            return(
                                                <Button
                                                    key={index}
                                                    type={ButtonType.Orange}
                                                    label={button.buttonText}
                                                    className={styles.topButton}
                                                    onClick={() => this.redirectToButtonUrl(button.destinationUrl)}
                                                />
                                            )
                                        })}
                                    </div>
                                }

                                
                                  <div className={styles.salesPitch}>
                                      {this.state.data.attributes.salesPitchContent && (
                                          <>
                                              <h2>{this.state.data.attributes.salesPitchTitle}</h2>
                                              <div className={styles.salesPitchContent}>
                                                  <ReactMarkdown>{this.state.data.attributes.salesPitchContent}</ReactMarkdown>
                                              </div>
                                              <div className={styles.salesPitchButtonDiv}>
                                                  <Button label={Localizer.occupationalHealthPageButtonText}
                                                          type={ButtonType.Orange}
                                                          className={styles.offerButton}
                                                          onClick={() => this.redirectToContactSupport()}
                                                  />
                                              </div>
                                          </>
                                      )}

                                      <div className={styles.salesPitchContainer}>
                                          <div className={styles.salesPitchImgContainer}>
                                              <img src={this.state.data.attributes.salesPitchImage.data.attributes.url}
                                                   className={styles.salesGuy}/>
                                          </div>
                                          <div className={styles.salesPitchContactInfo}>
                                              <div style={{margin: "auto"}}>
                                                  <ReactMarkdown>{this.state.data.attributes.salesPitchContactInfo}</ReactMarkdown>
                                              </div>
                                          </div>

                                      </div>

                                      {(this.state.data.attributes.references && this.state.data.attributes.references.length > 0) &&
                                          <>
                                              <div className={styles.carouselContainerDiv}>
                                                  <div className={styles.referencesheader}>
                                                      <h2>{Localizer.occupationalHealthPageReferences}</h2>
                                                  </div>
                                                  <Splide hasTrack={false} aria-label="References" options={{
                                                      autoplay: true,
                                                      interval: 10000,
                                                      rewind: true
                                                  }}>
                                                      <SplideTrack>
                                                          {this.state.data.attributes.references.map((reference, index) => {
                                                              return (
                                                                  <SplideSlide key={index}>
                                                                      <div className={styles.slideDiv}>
                                                                          <div className={styles.slideImgDiv}>
                                                                              <FaQuoteLeft/>
                                                                          </div>
                                                                          <div className={styles.slideTextDiv}>
                                                                              <ReactMarkdown>{reference.content ?? ''}</ReactMarkdown>
                                                                              <p className={styles.referee}>{reference.referee ?? ''}</p>
                                                                          </div>
                                                                      </div>
                                                                  </SplideSlide>
                                                              )
                                                          })}
                                                      </SplideTrack>
                                                      <div className="splide__progress">
                                                          <div className="splide__progress__bar progressBar" />
                                                      </div>
                                                  </Splide>
                                              </div>
                                          </>
                                      }
                            </div>

                                <div className={styles.occupationalHealthTeamRosterTitle}>
                                    <h2>{Localizer.occupationalHealthPageOccupationalHealthTeamRoster}</h2>
                                </div>
                                <div className={styles.occupationalHealthTeam}>
                                    {this.state.data.attributes.doctors &&
                                        <>
                                            <div className={styles.doctorsContainer}>
                                                {this.state.data.attributes.doctors.data.map((field) => {
                                                        return (
                                                            <div className={styles.doctor} key={`doctor_${field.id}`}
                                                                 onClick={async () => {PageRouteProvider.redirectAsync(PageDefinitions.doctor.route({params: {selectedDoctor: field.attributes.externalId}}))}}>
                                                                <img src={field?.attributes?.image?.data?.attributes?.url ?? FenixAppController.defaultDoctorImage()} className={styles.doctorImage}/>
                                                                <div className={styles.titleContainer}>
                                                                    <h3>{field.attributes.firstName + " " + field.attributes.lastName}</h3>
                                                                    <center>{field.attributes.title}</center>
                                                                </div>
                                                            </div>
                                                        )

                                                    })}
                                            </div>
                                        </>}
                                </div>
                                <div className={styles.appointmentButtonDiv}>
                                    <h3>Siirry tästä varaamaan työterveyshuollon aikoja:</h3>
                                <Button label={Localizer.homePageHeaderOccupationalHealthBooking}
                                        icon={"hospital"}
                                        type={ButtonType.Orange}
                                        className={styles.topButton}
                                        onClick={async () => FenixAppController.openOccupationalAppointments()}
                                />
                                </div>
                            </>
                        )}
                      <div className={styles.logoDiv}>
                        <img src={FenixAppController.getLogoForTHH(Localizer.language)} alt="Työterveyslaitos logo - Kuulumme työterveyshuollon laatuverkostoon" className={styles.logo} />
                      </div>
                    </div>
                </div>
            </PageContainer>
        );
    }
}


/*{this.state.data.attributes.salesPitchContent && (
    <div>
        <h2>{this.state.data.attributes.salesPitchTitle}</h2>
        <div className={"row"}>
            <div className={"col-md-3"}>
                <img src={`https://test-fenix.placeholder.fi/strapi-images/Riivari_Jere_2506lahi_Studio_Lindell_608ffe5bfe.jpg`}
                     className={styles.salesGuy}/>
            </div>
            <div className={"col-md-9"}>
                <ReactMarkdown>{this.state.data.attributes.salesPitchContent}</ReactMarkdown>
            </div>
        </div>
    </div>
)}*/
